import axios from 'axios';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import yoga from "../../assets/images/onboarding/yoga.jpg";
import { setChecksub } from '../../redux/slice/guardSlice';

const BASE_URL = "https://wbilzss.tickhighs.com";
const SERVICE_ID = "WELLNESS";
const COUNTRY_CODE = "211";

const OtpScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useNavigate();


  const msisdn = useSelector((state) => state?.guard?.msisdn);
  const currentStatus = useSelector((state) => state?.guard?.currentStatus);
  const msisdnFull = `${COUNTRY_CODE}${msisdn}`;

  const isActiveUser =
    currentStatus === "active" || currentStatus === "demo";

  const validationSchema = Yup.object({
    otp: Yup.string()
      .matches(/^\d+$/, "OTP must be numeric")
      .min(4, "OTP must be at least 4 digits")
      .max(6, "OTP must be at most 6 digits")
      .required("OTP is required")
  });

  // Poll checksub after new-user OTP verify success
  const pollChecksub = async () => {
    const check = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/sub/checksub?msisdn=${msisdnFull}&serviceId=${SERVICE_ID}`
        );
        const status = res.data?.data?.currentStatus?.toLowerCase();
        dispatch(setChecksub(status));
        return status === "active" || status === "demo";
      } catch {
        return false;
      }
    };

    // Immediate check
    if (await check()) { navigate("/home"); return; }

    // After 3 seconds
    await new Promise((r) => setTimeout(r, 3000));
    if (await check()) { navigate("/home"); return; }

    // After 5 more seconds
    await new Promise((r) => setTimeout(r, 5000));
    if (await check()) { navigate("/home"); return; }

    // Still not active
    navigate("/inprogress");
  };

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      if (isActiveUser) {
        // Active / Demo — validate Auth OTP
        const res = await axios.get(
          `${BASE_URL}/auth/otp/validate?msisdn=${msisdnFull}&otp=${values.otp}`
        );
        if (res.data.responseCode === "0") {
          dispatch(setChecksub(currentStatus));
          navigate("/home");
        } else {
          setFieldError("otp", "Invalid OTP. Please try again.");
        }
      } else {
        // New / Unsub — validate Subscription OTP
        const res = await axios.get(
          `${BASE_URL}/otp/validate_otp?msisdn=${msisdnFull}&otp=${values.otp}`
        );
        if (res.data.responseCode === "0") {
          // Start checksub polling
          await pollChecksub();
        } else {
          setFieldError("otp", "Invalid OTP. Please try again.");
        }
      }
    } catch (err) {
      // 400 responses from OTP validate come as axios errors
      const code = err?.response?.data?.responseCode;
      if (code === "1001") {
        setFieldError("otp", "OTP has expired. Please go back and request a new one.");
      } else if (code === "1002") {
        setFieldError("otp", "Invalid OTP. Please try again.");
      } else {
        navigate("/technical-error");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="inprogress">
      <div className="subsWrapper2">
        <div className="successBox">
          <img src={yoga} alt="wellness" className="img-fluid" style={{ width: "100%" }} />
        </div>
        <div className="subsWrapper">
          <div className="successCont">
            <h4>Wellness 360</h4>
            <p style={{ fontSize: 13, color: '#555', marginBottom: 8 }}>
              Enter the OTP sent to <strong>+{COUNTRY_CODE} {msisdn}</strong>
            </p>
            <Formik
              initialValues={{ otp: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid, dirty }) => (
                <Form>
                  <label>Enter OTP</label>
                  <div className="inputWrap">
                    <Field
                      type="text"
                      name="otp"
                      placeholder="Enter OTP"
                      maxLength={6}
                      onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6); }}
                    />
                  </div>
                  <ErrorMessage
                    name="otp"
                    component="div"
                    className="error"
                    style={{ color: 'red', fontSize: 12 }}
                  />
                  <div className="plnaBtn">
                    <button
                      type="submit"
                      disabled={isSubmitting || !isValid || !dirty}
                      style={{
                        opacity: isSubmitting || !isValid || !dirty ? 0.5 : 1,
                        cursor: isSubmitting || !isValid || !dirty ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {isSubmitting ? "Verifying..." : "Submit"}
                    </button>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 12 }}>
                    <span
                      style={{ fontSize: 13, color: '#888', cursor: 'pointer', textDecoration: 'underline' }}
                      onClick={() => navigate("/login")}
                    >
                      ← Back
                    </span>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpScreen;
